<template>
    <div @click="state.isOpen = true" class="cursor-pointer">
        <slot> </slot>
    </div>
    <MiniModalCustom
        :is-open="state.isOpen"
        @close="state.isOpen = false"
        title="Block User"
    >
        <div>
            You will not see posts from
            <strong>{{ props.username }}</strong> anymore.
        </div>
        <form action="/new-forum/block-user" method="POST">
            <input type="hidden" name="_token" :value="$root.csrfToken" />
            <input
                type="hidden"
                name="blocked_user_id"
                :value="props.blockedUserId"
            />
            <div class="flex mt-4 justify-between">
                <button
                    type="submit"
                    class="
                        rounded-full
                        bg-gradient-to-br
                        py-2
                        px-6
                        from-red-400
                        to-red-500
                        text-white
                        p-1
                    "
                >
                    Block User
                </button>
            </div>
        </form>
    </MiniModalCustom>
</template>

<script setup>
import { defineProps, reactive } from "vue";

const props = defineProps(["username", "blockedUserId"]);

const state = reactive({
    isOpen: false,
});
</script>
